import {GraphLevel} from '@domain/rcfa'

import {CanvasLevel, RcfaCanvasNode} from '../canvas.types'

export const findNode = (
  id: number | undefined,
  data: RcfaCanvasNode[]
): RcfaCanvasNode | undefined => data.find((node) => node.id === id)

export const findNodes = (ids: Array<number>, data: RcfaCanvasNode[]): RcfaCanvasNode[] => {
  return ids.map((nodeId) => findNode(nodeId, data)).filter((node) => node !== undefined)
}

export const findNodeInLevels = (
  id: number | undefined,
  levels: CanvasLevel[]
): RcfaCanvasNode | undefined => {
  return levels.flatMap((level) => level.nodes).find((node) => node.id === id)
}

export const findNodesInLevels = (ids: Array<number>, levels: CanvasLevel[]): RcfaCanvasNode[] => {
  return ids.map((nodeId) => findNodeInLevels(nodeId, levels)).filter((node) => node !== undefined)
}

export const findNodeLevel = (id: number, data: GraphLevel[]): number | undefined => {
  return data.find((level) => level.nodes.find((n) => n.id === id))?.level
}
